/* eslint-disable indent */
import actions from "./cartActions";

// computes the total quantity of items and computes the total amount,
// returns an object containing total quantity and total amount;
export const doSum = (cartItems = [], currency) => {
  let totalQuantity = cartItems.reduce((total, product) => total + product.quantity, 0);

  let totalAmount = cartItems
    .reduce((total, product) => total + product.amount[currency].amount * product.quantity, 0)
    .toFixed(2);

  return { totalQuantity, totalAmount };
};

export const CartReducer = (state, action) => {
  switch (action.type) {
    case actions.INIT:
      return {
        ...state,
        cartItems: action.payload.cartItems,
        currencies: action.payload.currencies,
        selectedCurrency: action.payload.selectedCurrency,
        ...doSum(action.payload.cartItems, action.payload.selectedCurrency) //does not include delivery charges
      };

    case actions.INCREASE: {
      const updatedCartitems = state.cartItems.map(item => {
        if (item.slug === action.payload && item.in_stock === null) {
          return { ...item, quantity: item.quantity + 1 };
        } else if (item.slug === action.payload && item.quantity < item.in_stock)
          return { ...item, quantity: item.quantity + 1 };
        else {
          return item;
        }
      });

      return {
        ...state,
        cartItems: updatedCartitems,
        ...doSum(updatedCartitems, state.selectedCurrency) //does not include delivery charges
      };
    }

    case actions.DECREASE: {
      const target = state.cartItems.findIndex(item => item.slug === action.payload);

      if (state.cartItems[target].quantity > 0) {
        const updatedCartitems = state.cartItems.map(item => {
          if (item.slug === action.payload) return { ...item, quantity: item.quantity - 1 };

          return item;
        });
        return {
          ...state,
          cartItems: updatedCartitems,
          ...doSum(updatedCartitems, state.selectedCurrency) //does not include delivery charges
        };
      }
      return state;
    }

    case actions.SET_LOCATION:
      return {
        ...state,
        locationDetails: {
          amount: action.payload.amount,
          duration: action.payload.duration,
          location: action.payload.location
        },
        deliveryAmount: action.payload.amount?.[state.selectedCurrency]?.amount ?? 0,
        ...doSum(state.cartItems, state.selectedCurrency) //does not include delivery charges
      };

    case actions.SET_CURRENCY:
      return {
        ...state,
        selectedCurrency: action.payload,
        deliveryAmount: state?.locationDetails?.amount?.[action.payload]?.amount ?? 0,
        ...doSum(state.cartItems, action.payload) //does not include delivery charges
      };

    case actions.RESET_DELIVERY_AMOUNT:
      return {
        ...state,
        ...doSum(state.cartItems, state.selectedCurrency), //does not include delivery charges
        deliveryAmount: 0
      };

    default:
      return state;
  }
};

export default CartReducer;
